import { Deal, DealStateEnum, DealStateLabelMap } from '../../gql/dealGql';
import { Deal as GeneratedDeal } from '../../gql/generated/graphql';

export const getBootedDealState = (deal?: Deal | GeneratedDeal | null) => {
  if (!deal || !deal.deal_dates?.dates) {
    return null;
  }
  const sortedDates = Object.entries(deal.deal_dates.dates)
    .filter(([key]) => ![DealStateEnum.Booted].includes(key as DealStateEnum))
    .sort(([, a], [, b]) => (new Date(a as string) > new Date(b as string) ? -1 : 1));
  const label = sortedDates[0]?.[0] as keyof typeof DealStateLabelMap;
  return label ? DealStateLabelMap[label] : null;
};
